import React, { useCallback, useEffect, useRef } from 'react';
import KendoReactColorPicker from '@Shared.Angular/kendo.react/KendoReactColorPicker';
import { colorPalette } from '@Shared.Angular/flowingly.services/data/colorPalette';
import {
  toggleColorPickerPopup,
  POPUP_CLASSES
} from '@Shared.Angular/kendo.react/KendoReactColorPickerUtils';
import { ThemeService } from '@Shared.Angular/flowingly.services/themeService';
import IconButton from '@Shared.Angular/flowingly.components/buttons/IconButton';

type Props = {
  value: string[];
  useDefaultPalette?: boolean;
};

export default function ColorPalette({
  value,
  useDefaultPalette = false
}: Props) {
  const customColors =
    value && value.length > 0 ? value : [ThemeService.DEFAULT_FONT_COLOR];
  const paletteColors = useDefaultPalette ? colorPalette : customColors;
  const kendoButtonRef = useRef<HTMLButtonElement | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const kendoContainer = containerRef.current.querySelector(
        '.kendo-react-color-picker'
      );
      if (kendoContainer) {
        const button = kendoContainer.querySelector(
          'button.k-input-button'
        ) as HTMLButtonElement;
        if (button) {
          kendoButtonRef.current = button;
        }
      }
    }
  }, []);

  const toggleColorPalette = useCallback(() => {
    toggleColorPickerPopup(kendoButtonRef.current, POPUP_CLASSES.COLOR_PALETTE);
  }, []);

  return (
    <div className="color-palette-custom-container" ref={containerRef}>
      <IconButton
        id="color-palette-view-button"
        iconClass="fa-grid-3"
        title="View colour palette"
        onClick={toggleColorPalette}
      />
      <KendoReactColorPicker
        views={['palette']}
        paletteSettings={{ palette: paletteColors, columns: 18, tileSize: 5 }}
        flatColorPickerSettings={{
          showButtons: false,
          showPreview: false,
          showClearButton: false,
          views: ['gradient']
        }}
        popupSettings={{
          className: 'form-theme-custom-color-palette'
        }}
      />
    </div>
  );
}
